import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail, Clock } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const navigation = [
    { name: 'Início', path: '/' },
    { name: 'Sobre Nós', path: '/sobre' },
    { name: 'Serviços', path: '/servicos' },
    { name: 'Horários Carreiras', path: '/horarios' },
    { name: 'Galeria', path: '/galeria' },
    { name: 'Recrutamento', path: '/recrutamento' },
    { name: 'Contactos', path: '/contacto' }
  ];

  return (
    <>
      {/* Top Bar */}
      <div className="bg-[#003d82] text-white py-2 px-4">
        <div className="container mx-auto flex flex-wrap justify-between items-center text-sm">
          <div className="flex items-center gap-4">
            <a href={`tel:${companyInfo.phone}`} className="flex items-center gap-2 hover:text-[#f5a623] transition-colors">
              <Phone size={14} />
              <span>{companyInfo.phone}</span>
            </a>
            <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-2 hover:text-[#f5a623] transition-colors">
              <Mail size={14} />
              <span className="hidden sm:inline">{companyInfo.email}</span>
            </a>
          </div>
          <div className="flex items-center gap-2">
            <Clock size={14} />
            <span>{companyInfo.hours.weekdays}</span>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header
        className={`sticky top-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-lg' : 'bg-white'
        }`}
      >
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img
                src="https://customer-assets.emergentagent.com/job_povoa-transport/artifacts/kfg763no_image001%202_Nero_AI_Image_Upscaler_Photo_Face.png"
                alt="Litoral Norte"
                className="h-12 w-auto"
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8">
              {navigation.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={scrollToTop}
                  className={`text-sm font-medium transition-colors relative group ${
                    location.pathname === item.path
                      ? 'text-[#003d82]'
                      : 'text-gray-700 hover:text-[#003d82]'
                  }`}
                >
                  {item.name}
                  <span
                    className={`absolute -bottom-1 left-0 h-0.5 bg-[#f5a623] transition-all duration-300 ${
                      location.pathname === item.path ? 'w-full' : 'w-0 group-hover:w-full'
                    }`}
                  />
                </Link>
              ))}
            </nav>

            {/* CTA Button */}
            <Link
              to="/contacto"
              className="hidden lg:block bg-[#f5a623] text-[#003d82] px-6 py-3 rounded-lg font-semibold hover:bg-[#e5a71b] transition-all duration-300 hover:shadow-lg hover:scale-105"
            >
              Pedir Orçamento
            </Link>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2 text-gray-700"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t">
            <nav className="container mx-auto px-4 py-4 flex flex-col gap-4">
              {navigation.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => { setIsMobileMenuOpen(false); scrollToTop(); }}
                  className={`text-base font-medium py-2 ${
                    location.pathname === item.path
                      ? 'text-[#003d82] border-l-4 border-[#f5a623] pl-4'
                      : 'text-gray-700'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <Link
                to="/contacto"
                onClick={() => { setIsMobileMenuOpen(false); scrollToTop(); }}
                className="bg-[#f5a623] text-[#003d82] px-6 py-3 rounded-lg font-semibold text-center"
              >
                Pedir Orçamento
              </Link>
            </nav>
          </div>
        )}
      </header>
    </>
  );
};
